import { getConnectionDetails, getConnectionElement } from "../../lib/connectionDetails";
import connectionHndb from '../../templates/connection.handlebars';

export const onCartPopup = (app) => {
    const elementChangesDispatcherRegister = (
        component,
        callback,
        extra
    ) => {
        let nodesToWatch, nodeToWatch, observer;
        switch (component) {
            case 'quick-search': {
                nodesToWatch = document.querySelectorAll('.quickSearchResults');
                nodesToWatch.forEach((node) => {
                    let observer = new MutationObserver(callback);
                    observer.observe(node, { childList: true, ...extra });
                });
                return;
            }
            case 'added-to-cart': {
                // todo
                return;
            }
            case 'cart-preview': {
                nodeToWatch = document.querySelector(
                    '#cart-preview-dropdown[data-dropdown-content]'
                );
                observer = new MutationObserver(callback);
                observer.observe(nodeToWatch, { childList: true, ...extra });
                return;
            }
            case 'quick-view': {
                nodeToWatch = document.querySelector('#modal .modal-content');
                observer = new MutationObserver(callback);
                observer.observe(nodeToWatch, { childList: true, ...extra });
                return;
            }
        }
    };

    const handleCartPreview = async(mutations, handleConnect, service) => {

        const details = await getConnectionDetails(service);
        if (!details || !details.positions.cart_popup) return;

        const connection = getConnectionElement(details);

        for (const mutation of mutations) {
            if (mutation.addedNodes) {
                const cartPreviewWrapper = [...mutation.addedNodes].find(
                    (item) => {
                        return item.className === 'previewCartWrapper';
                    }
                );
    
                if (cartPreviewWrapper) {
                    const previewContainer = cartPreviewWrapper.querySelector('.previewCart');

                    connection.connectionElement.style.textAlign = 'center';
                    previewContainer.append(connection.connectionElement);
                    connection.linkElement?.addEventListener('click', handleConnect);
                }
            }
        }
    }

    window.addEventListener('omnicustomer:ready', () => {
        const handleConnect = window.omniCustomer.api.handleConnect;
        elementChangesDispatcherRegister('cart-preview', (mutations) => handleCartPreview(mutations, handleConnect, app.service));
    });
}